import { useEffect } from 'react'
import { UserManager } from 'oidc-client-ts'
import { useNavigate } from 'react-router-dom'
import { PING_AUTH_URL, VID_BILT_LINKING_CLIENT_ID } from '@/config'
import { PATHS } from '@/router/paths'
import { useAppSelector } from '@/redux/hooks/hooks'
import { useFeatureSelector } from '@vrw/data/src/redux/features/features.selectors'
import { FeatureName } from '@vrw/data/src/redux/features/features.types'

const redBasePath = `${window.location.protocol}//${window.location.host}/en-us/virgin-red`

const userManager = new UserManager({
  authority: PING_AUTH_URL,
  client_id: VID_BILT_LINKING_CLIENT_ID,
  redirect_uri: `${redBasePath}${PATHS.MY_ACCOUNT_LINK_ACCOUNTS}`,
  response_type: 'code',
  scope: 'openid profile email phone offline_access',
  metadata: {
    authorization_endpoint: `${PING_AUTH_URL}/authorize`,
    token_endpoint: `${PING_AUTH_URL}/token`,
    end_session_endpoint: `${PING_AUTH_URL}/signoff`,
    revocation_endpoint: `${PING_AUTH_URL}/revoke`,
  },
})

export const useBiltLinking = () => {
  const webBiltFlag = useAppSelector(useFeatureSelector(FeatureName.WEB_BILT))
  const navigate = useNavigate()

  useEffect(() => {
    const url = new URL(window.location.href)
    if (webBiltFlag && url.searchParams.has('code')) navigate(PATHS.MY_ACCOUNT_LINK_ACCOUNTS)
  }, [navigate, webBiltFlag])

  const authenticate = async () => {
    await userManager.signinRedirect()
  }

  return {
    authenticate,
  }
}
